const notificationsSettings = {
    autoClose: 5000,
    closeButton: true,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    draggable: true,
};

export const getNotificationsSettings = () => notificationsSettings;
